export const FooterHandlers = () => {
    const toggles = document.querySelectorAll(
        ".footer__nav .navList li.hasChildren > .icon"
    );

    toggles.forEach((toggle) => {
        toggle.addEventListener("click", (event) => {
            toggleNavOpenState(event);
        });
    });
};

const toggleNavOpenState = (event) => {
    event.stopPropagation;
    const target = event.target as HTMLElement;

    if (!target) return;

    target.parentElement?.classList.toggle("open");
};
